"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerShadow = void 0;
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var RulerShadow = (function () {
    function RulerShadow(templateElement) {
        this.element = templateElement.cloneNode(true);
        this.element.style.opacity = '0.5';
        this.element.style.display = '';
        templateElement.parentNode.appendChild(this.element);
    }
    RulerShadow.prototype.dispose = function () {
        dom_1.DomUtils.hideNode(this.element);
    };
    return RulerShadow;
}());
exports.RulerShadow = RulerShadow;
